import React from "react";

const ConnectingButton = ({
  createRoomButton = false,
  buttonText,
  onClickHandler,
}) => {
  // console.log(buttonText);
  const buttonClass = createRoomButton
    ? `create_room_buttoon`
    : "join_room_button";
  return (
    <button className={buttonClass} onClick={onClickHandler}>
      {buttonText}
    </button>
  );
};

export default ConnectingButton;
